import React from 'react'

import clsx from 'clsx'
import dynamic from 'next/dynamic'

import { Container } from 'components/Grid'
import { EventContext } from 'context/EventContext'
import { HOME_VIDEO_LD } from 'helpers/SEOHelper'

import classes from './VideoExplainer.module.scss'

const YoutubeVideo = dynamic(() => import('components/YoutubeVideo'))

const video = { videoId: 'BCFrrTL_DC8' }

const VideoExplainer = () => {
  return (
    <div className={clsx('VideoExplainer', classes.root)}>
      <Container>
        <EventContext value={{ engagementComponent: 'homepage_video' }}>
          <YoutubeVideo video={video} />
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: HOME_VIDEO_LD }} />
        </EventContext>
      </Container>
    </div>
  )
}

export default VideoExplainer
